(function (angular) {

  angular.module("alk.import", []);

})(window.angular);

require("./importStyles.less");
require("./alkImport.service.js");
require("./importModal.controller.js");
require("./importFieldsModal.controller.js");
require("./importAddressModal.controller.js");
require("./importDetailsModal.controller.js");



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-import/module.js